import { FC } from "react";

export const NoDataMessage: FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="auto-cols-[1fr_minmax(0,20px)] grid-flow-col items-center py-5 px-4 text-sm text-stone-500 transition duration-300 ease-in-out">
      {children}
    </div>
  );
};
